var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternalMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.203,7.816 c-2.606-4.439-3.408-2.72-3.408-2.72v2.864l-1.289-0.344V2.232c0-0.057-1.461,0.019-1.461,0.019v5.413l-1.233,0.295V5.096 c0,0-0.802-1.718-3.408,2.72c0,0-1.89,3.666-1.174,6.443c0,0,0.267,1.394,3.017-0.745c0,0,0.622-0.391,1.413,0 c0.731,0.362,0.229-4.277,0.229-4.277l1.157-0.144v0.03v6.93c0,1.262-0.535,1.298-0.535,1.298H13.43 c-2.482,0-2.463,2.463-2.463,2.463c0,2.234,2.195,2.482,2.195,2.482h7.274c0.611,0,0.472,0.473,0.472,0.473 c0,0.511-0.492,0.492-0.492,0.492h-7.264c-1.957,0-1.9,1.9-1.9,1.9c0,1.947,1.833,1.938,1.833,1.938h7.188 c0.64,0,0.43,0.43,0.43,0.43c0,0.496-0.554,0.401-0.554,0.401h-8.305v1.566h8.687c1.871,0,1.737-2.005,1.737-2.005 c0-1.776-1.642-1.814-1.642-1.814h-7.369c-0.611,0-0.515-0.515-0.515-0.515c0-0.611,0.458-0.515,0.458-0.515h7.369 c1.68,0,1.68-1.966,1.68-1.966c0-1.814-1.661-1.852-1.661-1.852H13.43c-1.153-0.103-1.038-0.955-1.038-0.955 c-0.093-1.045,0.79-1.095,0.79-1.095h1.508c5.656,2.785,7.369-0.566,7.369-0.566c0.84-1.527-0.267-3.064-0.267-3.064 c-2.406-2.444-4.276,0.563-4.276,0.563V9.067l1.203,0.172c0,0-0.492,4.657,0.229,4.277c0.85-0.449,1.413,0,1.413,0 c2.749,2.138,3.017,0.745,3.017,0.745C24.093,11.482,22.203,7.816,22.203,7.816z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M15.185,20.301c0,2.419-1.961,4.38-4.38,4.38c-2.419,0-4.38-1.961-4.38-4.38 c0-2.419,1.961-4.38,4.38-4.38C13.224,15.921,15.185,17.882,15.185,20.301z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "13.77,19.051 12.035,19.051  12.035,17.316 9.652,17.316 9.652,19.051 7.917,19.051 7.917,21.434 9.652,21.434 9.652,23.169 12.035,23.169 12.035,21.434  13.77,21.434  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.967,6.32c0,0,2.234,2.367,2.73,6.09"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.637,6.297c0,0-2.234,2.367-2.73,6.09"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.376,16.119c0,0,0.611,2.348-2.596,2.978"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalMedicine);
export default __webpack_public_path__ + "static/media/internal_medicine.166de059518be58309fe7935541edaa2.svg";
export { ForwardRef as ReactComponent };